import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import type { SystemSummary } from "@shared/types";
import { StatusPill } from "../components/Status";

export function Catchments() {
  const [systems, setSystems] = useState<SystemSummary[]>([]);
  useEffect(() => {
    api<{ systems: SystemSummary[] }>("/api/systems").then((r) => setSystems(r.systems)).catch(() => setSystems([]));
  }, []);
  return (
    <section className="page-hero">
      <div className="wrap">
        <p className="kicker">Catchments</p>
        <h1>Flood System Records</h1>
        <p className="lede">Each record is a living intelligence graph, not a static catchment page.</p>
        <div className="results">
          {systems.map((s) => (
            <Link className="result" key={s.slug} to={`/system/${s.slug}`}>
              <div className="record-meta">
                <span>{s.kind}</span>
                <span>{s.state}</span>
                {s.synthetic ? <StatusPill status="DEMO / SYNTHETIC" /> : <StatusPill status="Public technical source" />}
              </div>
              <h3>{s.name}</h3>
              <p className="muted">{s.summary}</p>
              <p className="muted small">
                {s.studyCount} identified public studies · {s.modelCount} model versions · {s.eventCount} events
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
